import { Phone } from "lucide-react";
import { SITE } from "../data/site";
import { useLang } from "../i18n";

export const WhatsAppIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.52 3.48A11.91 11.91 0 0 0 12.04 0C5.46 0 .1 5.35.1 11.93c0 2.1.55 4.16 1.6 5.97L0 24l6.27-1.64a11.9 11.9 0 0 0 5.76 1.47h.01c6.58 0 11.93-5.35 11.93-11.93 0-3.19-1.24-6.19-3.45-8.42zM12.04 21.9a9.9 9.9 0 0 1-5.05-1.38l-.36-.22-3.72.98 1-3.63-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.89 9.88zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.7.63.71.22 1.36.19 1.87.11.57-.08 1.76-.72 2-1.41.25-.7.25-1.29.18-1.42-.08-.12-.28-.2-.57-.34z" />
  </svg>
);

export const FloatingWhatsApp = () => (
  <a
    href={SITE.whatsapp}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat on WhatsApp"
    className="fixed z-50 bottom-24 md:bottom-6 right-5 md:right-6 w-14 h-14 bg-[#25D366] text-white flex items-center justify-center shadow-[4px_4px_0_#0A1F44] transition-[transform,box-shadow] duration-200 hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[1px_1px_0_#0A1F44]"
  >
    <WhatsAppIcon size={26} />
  </a>
);

export const MobileStickyBar = () => {
  const { t } = useLang();
  return (
    <>
      <div className="h-14 md:hidden" />
      <div className="fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 md:hidden border-t border-gray-200" data-testid="mobile-sticky-bar">
        <a href={SITE.phone1Href} data-testid="sticky-call-button"
           className="flex items-center justify-center gap-2 bg-navy text-white font-heading text-xs font-bold uppercase tracking-[0.15em] py-4">
          <Phone size={16} /> {t("sticky.call")}
        </a>
        <a href={SITE.whatsapp} target="_blank" rel="noreferrer" data-testid="sticky-whatsapp-button"
           className="flex items-center justify-center gap-2 bg-[#25D366] text-white font-heading text-xs font-bold uppercase tracking-[0.15em] py-4">
          <WhatsAppIcon size={16} /> WhatsApp
        </a>
      </div>
    </>
  );
};
